import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { catchError, map } from "rxjs/operators";
import { ActivityVerify } from "../model/activity-verify.model";

@Injectable()
export class ActivityVerifyService {
    private activityVerifyUrl = 'activity-verify';
    constructor(
        private http: Http,
    ){}

    get(domain: string, identifier: string): Observable<ActivityVerify> {
        return this.http.get(`${this.activityVerifyUrl}/${domain}/${identifier}`)
        .pipe(
            map((res: Response) => {
                const data = res.json();
                const activityVerify = new ActivityVerify();

                activityVerify.register = data['Register'];
                activityVerify.requester = data['Requester'];
                activityVerify.interested = data['Interested'];
                activityVerify.itemName = data['ItemName'];
                activityVerify.serialNumber = data['SerialNumber'];
                activityVerify.itemTag = data['ItemTAG'];
                activityVerify.realizationDate = data['RealizationDate'];
                activityVerify.report = data['Report'];

                return activityVerify;
            }),
            catchError((error: any) => Observable.throw(error.json().error || 'Server error'))
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/verify/shared/service/activity-verify.service.ts